import { render, staticRenderFns } from "./customer-shipment-total.vue?vue&type=template&id=253f6296"
import script from "./customer-shipment-total.vue?vue&type=script&lang=js"
export * from "./customer-shipment-total.vue?vue&type=script&lang=js"
import style0 from "./customer-shipment-total.vue?vue&type=style&index=0&id=253f6296&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports